
/**
 * 拼接完整的图片URL
 */
export function fullUrl(url) {
    if (!url || url === '' || url === null || url === undefined) {
        return ''
    }

    // 如果已经是完整的HTTP/HTTPS URL，直接返回
    if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
    }

    if (import.meta.env.VITE_APP_BASE_API === '/server') {
        return url
    }

    // console.log(import.meta.env.VITE_APP_BASE_API+ url)
    return import.meta.env.VITE_APP_BASE_API + url
    // return import.meta.env.VITE_APP_BASE_API +'/dev-api'+ url
}

// export function fullUrl(url) {
//   if (!url) return ''
//
//   // 已经是完整 URL，直接返回
//   if (url.startsWith('http://') || url.startsWith('https://')) {
//     return url
//   }
//
//   // 头像、上传文件这类静态资源，本来就是 /profile 开头，直接从根路径访问
//   if (url.startsWith('/profile/')) {
//     return url
//   }
//
//   // 其它接口才拼接 API 前缀（/server）
//   return import.meta.env.VITE_APP_BASE_API + url
// }